import {createContext, useContext} from 'react'

export const MultiActionContext = createContext()
export const useMultiActionContext = () => useContext(MultiActionContext)
